'use client'

import { asset } from '@/lib/assets'

type PaymentPendingModalProps = {
  isOpen: boolean
  onClose: () => void
  transactionsHref?: string
}

export function PaymentPendingModal({ isOpen, onClose, transactionsHref = '/my-transactions' }: PaymentPendingModalProps) {
  if (!isOpen) return null

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-body">
          <div className="modal-icon-wrapper">
            <img
              src={asset('/assets/gifs/payment_required.gif')}
              alt=""
              className="modal-icon"
              aria-hidden
            />
          </div>

          <div className="modal-text-content">
            <h2 className="modal-heading">Payment Status Pending</h2>

            <p className="modal-paragraph">
              We&apos;re still processing your payment. We&apos;ll update your payment status within 3 working days.
            </p>
            <p className="modal-paragraph">
              For more information, please check{' '}
              <a href={transactionsHref} className="transactions-link">My Transactions</a>.
            </p>

            <div className="button-group">
              <button className="close-button" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          backdrop-filter: blur(8px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1003;
          animation: fadeIn 0.2s ease-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .modal-content {
          background: white;
          border-radius: 24px;
          padding: 3rem;
          max-width: 580px;
          width: 90%;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          animation: slideUp 0.3s ease-out;
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .modal-body {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
        }

        .modal-icon-wrapper {
          margin-bottom: 2rem;
        }

        .modal-icon {
          width: 80px;
          height: 80px;
        }

        .modal-text-content {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .modal-heading {
          font-size: 1.75rem;
          font-weight: 700;
          color: #5B4EF5;
          margin: 0 0 1.25rem 0;
          line-height: 1.3;
        }

        .modal-paragraph {
          font-size: 1rem;
          color: #000000;
          line-height: 1.6;
          margin: 0 0 1.5rem 0;
          max-width: 460px;
        }

        .transactions-link {
          color: #5B4EF5;
          font-weight: 600;
          text-decoration: underline;
          text-underline-offset: 2px;
        }

        .transactions-link:hover {
          color: #4338CA;
        }

        .button-group {
          width: 100%;
          margin-top: 0.5rem;
        }

        .close-button {
          width: 100%;
          padding: 0.875rem 2rem;
          background: linear-gradient(135deg, #6B5CE7 0%, #5B4EF5 100%);
          color: white;
          border: none;
          border-radius: 12px;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(91, 78, 245, 0.3);
        }

        .close-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(91, 78, 245, 0.4);
          background: linear-gradient(135deg, #7C6EE8 0%, #6B5CE7 100%);
        }

        .close-button:active {
          transform: translateY(0);
        }

        @media (max-width: 640px) {
          .modal-content {
            padding: 2rem 1.5rem;
            max-width: 95%;
          }
          .modal-heading {
            font-size: 1.5rem;
          }
          .modal-paragraph {
            font-size: 0.9375rem;
          }
        }
      `}</style>
    </div>
  )
}
